export const FIREARM_EVIDENCE_CATEGORY_OPTIONS = [
  { value: 'issuance_condition', label: 'Issued Firearm Image' },
  { value: 'return_condition', label: 'Return-Condition Image' },
  { value: 'damage', label: 'Damage' },
  { value: 'defect', label: 'Defect' },
  { value: 'repair', label: 'Repair' },
  { value: 'other', label: 'Other' },
] as const;

export type FirearmEvidenceCategory = typeof FIREARM_EVIDENCE_CATEGORY_OPTIONS[number]['value'];

export interface FirearmEvidence {
  id: number;
  firearm: number;
  issuance?: number | null;
  return_record?: number | null;
  firearm_serial_number: string;
  category: FirearmEvidenceCategory;
  category_display: string;
  original_name: string;
  mime_type: string;
  file_size: number;
  sha256_hash: string;
  width: number | null;
  height: number | null;
  uploaded_by_display: string;
  uploaded_at: string;
  notes: string;
  preview_url: string;
  download_url: string;
}

export interface FirearmEvidenceFilters {
  issuance?: number;
  return_record?: number;
}

export interface FirearmEvidenceUpload {
  file: File;
  notes?: string;
}

export const FIREARM_EVIDENCE_ALLOWED_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;

export const FIREARM_EVIDENCE_MAX_BYTES = 5 * 1024 * 1024;
